






import PosterUser from "../mixins/poster-user";
import { AutorPoster } from "../models/participante";
import { PosterWithLocales } from "../store/poster";

interface DetailPosterCarta {
  nombres: string;
  apellidos: string;
  id_poster: string | number;
  institucion: string;
  titulo: string;
  tipo: number | string;
  tipo_aceptacion: string;
  autores: AutorPoster[];
}

export default PosterUser.extend({
  data: () => ({
    lazy: true,
  }),

  computed: {
    formatPosterData(): DetailPosterCarta | null {
      const poster: PosterWithLocales | null = this.poster;
      if (!poster) {
        return null;
      }

      for (const autor of poster.autores) {
        if (autor.protected) {
          return {
            nombres: autor.nombres,
            apellidos: autor.apellidos,
            titulo: poster.titulo,
            id_poster: poster.codigo,
            institucion: autor.institucion,
            tipo: poster.tipo,
            tipo_aceptacion: poster.tipo_aceptacion,
            autores: poster.autores,
          };
        }
      }

      return null;
    },
  },

  methods: {
    async submit() {
      await this.updateItem();
      const data = this.formatPosterData;
      if (!data) {
        return;
      }

      return this.$store.dispatch("certificados/carta", { data });
    },
  },
});
